import React from "react";
import { ControlLabel } from "react-bootstrap";

function MandatoryLabel({ title }) {
    return (
        <ControlLabel>
            {title} <span style={{ color: "red" }}>*</span>
        </ControlLabel>
    );
}

export default MandatoryLabel;
